import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

/**
 * Wrapper for inline cell editors (Withholding Tax / Valid Until) — fills the whole cell and
 * vertically centers the field so the row doesn't break / shift while editing.
 */
export const CellEditorWrapper = styled(Box)(({ theme }) => ({
  width: '100%',
  height: '100%',
  padding: theme.spacing(0, 1),
  display: 'flex',
  alignItems: 'center',
}));
